<template>
    <form class="bg-white p-4 rounded shadow-sm" id="shareholder_form">
        <div v-text="$t('label.create_shareholder')" class="mb-4 h5"></div>
        <div v-for="(record, index) in records" :key="index" class="row align-items-end">
            <div class="col-5 my-2">
                <label :for="`iban_${index}`" v-text="$t('label.iban')"></label>
                <input :id="`iban_${index}`"
                       :name="`iban_${index}`"
                       :style="isValidIban(record.iban) ? '' : 'border-color: red !important;'"
                       @keyup="checkIban(record.iban, index)"
                       class="form-control en_num transfers_destination_number"
                       dir="ltr"
                       type="text"
                       v-model="record.iban"
                >
            </div>
            <div class="col-5 my-2" v-if="record.full_name !== ''">
                <label :for="`full_name_${index}`" v-text="$t('label.shareholder_name')"></label>
                <input :id="`full_name_${index}`"
                       :name="`full_name_${index}`"
                       disabled
                       class="form-control"
                       type="text"
                       v-model="record.full_name"
                >
            </div>
            <div class="col-2 my-2" v-if="record.hashid !== ''">
                <button type="button"
                        class="btn btn-danger"
                        @click="deleteShareholder(record.hashid, record.iban, index)"
                        v-text="$t('label.delete')"
                ></button>
            </div>
        </div>
    </form>
</template>

<script>
    import Inputmask from "inputmask";
    import IranSheba from "iran-sheba";
    import {walletService, ibanInfo, walletShareHolderService} from "@/common/api.service";

    export default {
        props: {
            records: {
                required: true,
                type: Array,
            },
        },
        data() {
            return {
                wallet_hashid: '',
                last_iban_check: '',
            };
        },
        watch: {
            records() {
                setTimeout(() => {
                    this.initShebaMask();
                }, 500);
            },
        },
        methods: {
            initShebaMask() {
                Inputmask("IR 9999-9999-9999-9999-9999-9999")
                    .mask(document.querySelectorAll('.transfers_destination_number'));
            },
            getBankName(iban) {
                iban = iban.replace(/[\-_ ]/g, '');

                return IranSheba.recognize(iban).persianName;
            },
            deleteShareholder(hashid, iban, index) {
                iban = iban.replace(/[\-_ ]/g, '');
                this.records.splice(index, 1);

                let params = {
                    hashid,
                    iban,
                };

                walletShareHolderService.shareholderIbanDelete(params);
            },
            isValidIban(iban) {
                iban = iban.replace(/[\-_ ]/g, '');

                if (iban.length !== 26) { // 26 with IR
                    return false;
                }

                return IranSheba.isValid(iban);
            },
            checkIban(iban, index) {
                iban = iban.replace(/[\-_ ]/g, '');

                if (! this.isValidIban(iban)) {
                    return;
                }

                if (this.last_iban_check === iban) {
                    return;
                } else {
                    this.last_iban_check = iban;

                    setTimeout(() => {
                        this.last_iban_check = '';
                    }, 1000);
                }

                let params = {
                    iban: iban,
                };

                let hashid = this.wallet_hashid;

                ibanInfo.get(params, hashid).then(res => {
                    let data = res.data.data;
                    this.records[index].full_name = data.first_name + ' ' + data.last_name;
                    this.records[index].hashid = data.hashid;

                    this.records.push({
                        iban: '',
                        full_name: '',
                        hashid: '',
                    });

                    this.$forceUpdate();
                });
            },
            formatAmount(amount) {
                return parseInt(String(amount).replace(/,/g, ''));
            },
        },
        mounted() {
            this.initShebaMask();

            let params = {
                wallet_prefix: 'A',
            };

            walletService.get(params).then(res => {
                this.wallet_hashid = res.data.data.filter(item => item.status === 1)
                    .map(item => {
                        return {
                            hashid: item.id,
                            balance: this.formatAmount(item.available_amount),
                        };
                    })
                    .reduce((index, next) => (index.balance > next.balance) ? index : next)
                    .hashid;
            });
        },
    }
</script>
